import { MENTION_COLOR_MAP } from '@/app/constants';
import type { ImagePrompt, ReferencePrompt, ViduV1Element } from '@/app/types';

export function isImageType(element?: ViduV1Element | ImagePrompt): element is ImagePrompt {
  return !!(element as ImagePrompt)?.sourceImage || !!(element as ImagePrompt)?.sourceImagePreview;
}

/**
 * 根据元素类型和状态获取mention的颜色
 *
 * @param element - 主体
 * @param referenceType - 类型，主体/图片
 * @param color - 自定义颜色
 * @returns mention对应的颜色值
 */
export const getMentionColor = ({
  element,
  type,
  color,
}: {
  element?: ViduV1Element | ImagePrompt;
  type?: ReferencePrompt['type'];
  color?: string;
}): string => {
  const isImage = isImageType(element);
  if (type === 'image' || isImage) {
    return MENTION_COLOR_MAP.image;
  }
  if (type === 'video') {
    return MENTION_COLOR_MAP.video;
  }
  if (!isImage && (type === 'element' || element)) {
    if (!element?.id) {
      return MENTION_COLOR_MAP.forbidden;
    }
    // 如果是已入选的共享主体，使用share_reference颜色
    if (element.share_meta?.status === 'approved') {
      return MENTION_COLOR_MAP.share_reference;
    }
    return MENTION_COLOR_MAP.element;
  }

  if (type) {
    return MENTION_COLOR_MAP[type] || MENTION_COLOR_MAP.image;
  }

  if (color) {
    return color;
  }

  return MENTION_COLOR_MAP.image;
};
